<template>
    <div class="band_block">
        <h4 class="mb-4">Add matching bands :</h4>
        <div class="for_scroll" ref="scrollContainer">
            <div class="band_flex">
                <div v-for="band in item.bands" :key="band.id" class="text-center band_box pe-0">
                    <div class="pop_band border"  @click="openModal(band)">
                        <img width="129"  height="129" :alt="band.product_name" :src="band.front_image" />
                        <h5 class="mb-1">{{band.product_name}}</h5>
                        <p class="text-left mb-1">
                            <span>{{band.metal_name}} </span>
                        </p>
                        <div class="rec_box rec_box_trending" v-if="band.is_trending === 1">Trending </div>
                        <div class="rec_box" v-if="band.is_recommended === 1">Best Match</div>
                        <h6 class="text-start mb-2"> 
                            <div class="d-flex  align-items-center">
                                <span class="">{{$formatPrice(band.price)}}</span>
                                <span class="discounted-price ms-2" v-if="!$country.is_india && band.discount_label"> {{$formatPrice(band.mrp)}}</span>
                            </div>
                            <div class="d-flex align-items-center gap-1">
                                <span v-if="!$country.is_india && band.discount_label" class="disc_chip_pdp my-2 ms-0">{{ band.discount_label }}% OFF</span>
                                <span v-if="!$country.is_india && band.discount_label && band.lowest_price_label" class="lowest_price_plp ">Lowest Price Ever</span>
                            </div>
                        </h6>
                        <div class="metal_color d-flex mb-2">
                            <div class="metal_box white"></div>
                            <div class="metal_box yellow"></div>
                            <div class="metal_box rose"></div>
                        </div>
                        <div class="cta_btns">
                            <img width="16" height="16" src="~/assets/svg/addgreen.svg" alt="add icon">
                            <h3 class="mb-0 ms-1">Add</h3>
                        </div>
                    </div>
                </div>

                <CyoBandMatchingModal v-if="toggleModal" :band="bandData" :sub_type="sub_type" ref="modalRef" />
            </div>
        </div>
    </div>
</template>

<script setup>

    const { item, sub_type } = defineProps(['item', 'sub_type'])
    const { $country, $formatPrice} = useNuxtApp()

    const bandData = ref(false)
    const checkbox = ref(false)
    const toggleModal = ref(false)
    const isDown = ref(false)
    const scrollContainer = ref('')
    const startX = ref(0);
    const scrollLeft = ref(0);
    const modalRef = ref(false)

    function initHorizontalScroll() {
        if(scrollContainer.value){
            const scroll_Container = scrollContainer.value;

            scroll_Container.addEventListener('mousedown', (e) => {
                isDown.value = true;
                startX.value = e.pageX - scroll_Container.offsetLeft;
                scrollLeft.value = scroll_Container.scrollLeft;
            });

            scroll_Container.addEventListener('mouseleave', () => {
                isDown.value = false;
            });

            scroll_Container.addEventListener('mouseup', () => {
                isDown.value = false;
            });

            scroll_Container.addEventListener('mousemove', (e) => {
                if (!isDown.value) return;
                e.preventDefault();
                const x = e.pageX - scroll_Container.offsetLeft;
                const walk = (x - startX.value) * 3; // Adjust scrolling speed here
                scroll_Container.scrollLeft = scrollLeft.value - walk;
            });
        }
    }

    const openModal = ( band ) =>{
                toggleModal.value = false
                nextTick(() => {
                    bandData.value = band
                    toggleModal.value = true
                });
            }
    
    onMounted(() => {
        initHorizontalScroll();
        
    })

    
  
</script>

<style scoped>
::-webkit-scrollbar {
    width: 2px;
    height: 3px;
}

/* Track */
::-webkit-scrollbar-track {
    background: #f5f5f5; 
}
 
/* Handle */
::-webkit-scrollbar-thumb {
    background: #c4c4c4;  
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
    background: #c4c4c4; 
}
.rec_box.rec_box_trending {
    background: #d59066;
}
.rec_box {
    position: absolute;
    top: -1px;
    left: -1px;
    font-size: 12px;
    background: var(--green);
    color: #fff;
    border-radius: 3px 0 0 0;
    padding: 4px 20px 4px 10px;
    min-width: auto;
    text-align: center;
    clip-path: polygon(0 0, 100% 0%, 85% 100%, 0% 100%);
}

button{
    height: 40px !important;
    line-height: 1;
}
.band_block {
    margin-top: 5%;
}
.pop_band {
    border: 1px solid #ccc;
    border-radius: 5px;
    padding: 10px;
    position:relative;
}
.band_box{
    cursor: pointer;
    position: relative;
}
.band_block h4 {
    font-size: 18px;
    color: #000;
    font-weight: 600;
}
.band_box h5 {
    font-size: 13px;
    text-align: left;
    color: #363030;
    font-weight: 600;
    min-height: 32px;
}
p{
    font-size: 13px;
    text-align: left;
    font-weight: 400;
}
p span{
    display: block;
}

.cta_btns {
    display: flex;
    align-items: center;
    justify-content: flex-start;
}

.cta_btns.cta_btns_mod h3{
    color: #000;
    text-decoration: none;
}
.cta_btns h3 {
    font-size: 14px;
    font-weight: bold;
    text-decoration: underline;
    color: var(--green);
    margin-right: 15px;
}
 h6 {
    font-size: 14px;
    font-weight: bold;
}

h6 .discounted-price {
    color: #939393;
    text-decoration: line-through;
    margin-left: 0;
    /* margin-top: 5px; */
    display: block;
    font-size: 13px;
}

.disc_chip_pdp{
    font-size: 10px;
    border-radius: 2px !important;
}
.metal_color .metal_box {
    height: 18px;
    width: 18px;
    margin-right: 5px;
    cursor: pointer;
    border: 2px solid #fff;
    border-radius: 4px;
}
.metal_color .metal_box.active {
    border: 2px solid #668b84;
}
.metal_color .yellow {
    background: #f3dda1;
}
.metal_color .rose {
    background: #f3b089;
}
.metal_color .white, .metal_color .platinum {
    background: #eff0f0;
}
.for_scroll {
    overflow-x: scroll;
    overflow-y: hidden;
    padding-bottom: 5px;
   
}

.for_scroll .band_flex {
    width: max-content !important;
    display: flex;
}
.band_box {
    min-width: 155px;
    margin-right: 10px;
}
.band_box:last-child{
    margin-right: 1px;
}
@media(max-width: 1130px){
   
}
</style>
